export default __webpack_public_path__ + "static/media/cm new logos N.6f4f7969.svg";